// @flow
import {type SagaIterator} from 'redux-saga';

import {fork} from 'redux-saga/effects';

import ecommerce from './ecommerce';

/**
 * EEC - Category events.
 */
export default function* category(): SagaIterator {
    yield fork(ecommerce);
}
